module.exports = __webpack_public_path__ + "static/media/meeting_room-black-18dp.ccf19a14.svg";